import Swal from 'sweetalert2';

// Toast configuration
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

// Toast functions
export const toast = {
  success: (message: string) => {
    Toast.fire({
      icon: 'success',
      title: message
    });
  },
  error: (message: string) => {
    Toast.fire({
      icon: 'error',
      title: message
    });
  },
  warning: (message: string) => {
    Toast.fire({
      icon: 'warning',
      title: message
    });
  },
  info: (message: string) => {
    Toast.fire({
      icon: 'info',
      title: message
    });
  }
};

// Modal functions
export const modal = {
  confirm: async (title: string, text: string, confirmButtonText = 'Yes', cancelButtonText = 'No') => {
    const result = await Swal.fire({
      title,
      text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText,
      cancelButtonText
    });
    
    return result.isConfirmed;
  },
  
  alert: async (title: string, text: string, icon: 'success' | 'error' | 'warning' | 'info' = 'info') => {
    await Swal.fire({
      title,
      text,
      icon
    });
  },
  
  prompt: async (title: string, inputPlaceholder = '', inputValue = '') => {
    const result = await Swal.fire({
      title,
      input: 'text',
      inputPlaceholder,
      inputValue,
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'You need to enter something!';
        }
        return null;
      }
    });
    
    return result.value;
  }
};

const SweetAlert = {
  toast,
  modal
};

export default SweetAlert;
